<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import { useAuthStore, authService } from '@adaptcx/shared'

const authStore = useAuthStore()
let stopSessionWatcher: (() => void) | null = null

// Handle theme initialization
onMounted(() => {
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark')
  }
})

// Restore auth state from localStorage on app init
onMounted(async () => {
  // First, instantly restore from localStorage for fast UI
  authStore.initFromStorage()

  // Then verify/refresh user data from API in background
  const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token')
  if (token) {
    try {
      await authStore.fetchUser()
      // Start session expiry watcher after successful auth restore
      stopSessionWatcher = authService.startSessionExpiryWatcher()
    } catch (e) {
      // Token invalid/expired - will be handled by router guard
      console.error('Failed to restore auth state:', e)
    }
  }
})

onUnmounted(() => {
  // Cleanup session watcher
  if (stopSessionWatcher) {
    stopSessionWatcher()
    stopSessionWatcher = null
  }
})
</script>

<template>
  <RouterView />
</template>
